import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChartLine, faList, faLightbulb } from '@fortawesome/free-solid-svg-icons';

import useToken from "./useToken";
import Login from "./login";
import { hasProductPermission } from '../utils/permissions';


const Header = () => {
    const { token, setToken } = useToken();
    const location = useLocation();

    const userName = JSON.parse(sessionStorage.getItem('userName'))|| "Risk Desktop";
    const canAccessInsightStudio = hasProductPermission('insight_studio');

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const navigate = useNavigate();

    const handleLogout = () => {
        const token = sessionStorage.getItem('token');
        console.log('============logout header response==========', token);

        if (token) {
            sessionStorage.removeItem('token');
            console.log('Token removed from sessionStorage');
            navigate("/login");
        } else {
            console.log('No token found in sessionStorage');
        }
    };

    // Show dropdown on hover
    const handleMouseEnter = () => setDropdownOpen(true);
    const handleMouseLeave = () => setDropdownOpen(false);

    const isActive = (path) => location.pathname === path;

    return (
        <header
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "15px 30px",
                background: "linear-gradient(135deg, #1a1f3a 0%, #111525 100%)",
                color: "#fff",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
            }}
        >
            <div className="navless-header">
                <h4 style={{ fontWeight: 600, margin: 0, marginBottom: "5px" }}>Dashboard</h4>
                <p style={{ margin: 0, fontSize: "12px", opacity: 0.8 }}>Powered By <a href="https://www.contextanalytics-ai.com/" target="_blank" className="underline-link">Context Analytics</a></p>
            </div>

            {/* Center: Navigation Menu */}
            <nav style={{ display: "flex", gap: "10px" }}>
                <a 
                    href="/dashboard" 
                    style={{ 
                        color: "#fff", 
                        textDecoration: "none", 
                        fontSize: "15px",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        background: isActive('/dashboard') ? "rgba(43, 151, 240, 0.2)" : "transparent",
                        border: isActive('/dashboard') ? "1px solid #2b97f0" : "1px solid transparent",
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontWeight: isActive('/dashboard') ? "600" : "400"
                    }}
                    onMouseEnter={(e) => {
                        if (!isActive('/dashboard')) {
                            e.target.style.background = "rgba(255, 255, 255, 0.05)";
                            e.target.style.border = "1px solid rgba(255, 255, 255, 0.1)";
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (!isActive('/dashboard')) {
                            e.target.style.background = "transparent";
                            e.target.style.border = "1px solid transparent";
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faChartLine} />
                    Dashboard
                </a>
                <a 
                    href="/watchlist" 
                    style={{ 
                        color: "#fff", 
                        textDecoration: "none", 
                        fontSize: "15px",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        background: isActive('/watchlist') ? "rgba(43, 151, 240, 0.2)" : "transparent",
                        border: isActive('/watchlist') ? "1px solid #2b97f0" : "1px solid transparent",
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontWeight: isActive('/watchlist') ? "600" : "400"
                    }}
                    onMouseEnter={(e) => {
                        if (!isActive('/watchlist')) {
                            e.target.style.background = "rgba(255, 255, 255, 0.05)";
                            e.target.style.border = "1px solid rgba(255, 255, 255, 0.1)";
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (!isActive('/watchlist')) {
                            e.target.style.background = "transparent";
                            e.target.style.border = "1px solid transparent";
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faList} />
                    Watchlist
                </a>
                {canAccessInsightStudio && (
                    <a
                        href="/insight-studio"
                        style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontSize: "15px",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            background: isActive('/insight-studio') ? "rgba(43, 151, 240, 0.2)" : "transparent",
                            border: isActive('/insight-studio') ? "1px solid #2b97f0" : "1px solid transparent",
                            transition: "all 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontWeight: isActive('/insight-studio') ? "600" : "400"
                        }}
                        onMouseEnter={(e) => {
                            if (!isActive('/insight-studio')) {
                                e.target.style.background = "rgba(255, 255, 255, 0.05)";
                                e.target.style.border = "1px solid rgba(255, 255, 255, 0.1)";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!isActive('/insight-studio')) {
                                e.target.style.background = "transparent";
                                e.target.style.border = "1px solid transparent";
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faLightbulb} />
                        Insight Studio
                    </a>
                )}
            </nav>

            {/* Right: Username and Dropdown */}
            <div
                style={{ position: "relative" }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <button
                    style={{
                        background: "rgba(43, 151, 240, 0.1)",
                        border: "1px solid rgba(43, 151, 240, 0.3)",
                        color: "#fff",
                        fontSize: "14px",
                        cursor: "pointer",
                        padding: "10px 18px",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                        fontWeight: "500"
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = "rgba(43, 151, 240, 0.2)";
                        e.target.style.borderColor = "#2b97f0";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = "rgba(43, 151, 240, 0.1)";
                        e.target.style.borderColor = "rgba(43, 151, 240, 0.3)";
                    }}
                >
                    Welcome, {userName} <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: "5px", fontSize: "12px" }} />
                </button>

                {/* Dropdown Menu */}
                {dropdownOpen && (
                    <div
                        style={{
                            position: "absolute",
                            right: 0,
                            top: "100%",
                            background: "linear-gradient(135deg, #1a1f3a 0%, #111525 100%)",
                            color: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.3)",
                            width: "160px",
                            zIndex: 1000,
                            border: "1px solid rgba(43, 151, 240, 0.2)",
                            overflow: "hidden"
                        }}
                    >
                        <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                            <li
                                style={{
                                    padding: "12px 20px",
                                    cursor: "pointer",
                                    textAlign: "center",
                                    transition: "background 0.3s ease"
                                }}
                                onMouseEnter={(e) => e.target.style.background = "rgba(43, 151, 240, 0.2)"}
                                onMouseLeave={(e) => e.target.style.background = "transparent"}
                            >
                                <a
                                    href="/login"
                                    style={{ 
                                        textDecoration: "none", 
                                        color: "#fff",
                                        fontSize: "14px",
                                        fontWeight: "500"
                                    }}
                                    onClick={handleLogout}
                                >
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
